/**
 * PreviewProofTable — Comparison table with highlight column
 */

interface ProofRow {
  criterion: string;
  us: string;
  other: string;
}

interface PreviewProofTableProps {
  data: {
    title?: string;
    subtitle?: string;
    headers?: string[];
    highlightColumn?: number;
    rows?: ProofRow[];
  };
}

export function PreviewProofTable({ data }: PreviewProofTableProps) {
  const headers = data.headers || ["Kriterium", "Wir", "Andere"];
  const hc = data.highlightColumn ?? 1;
  return (
    <section className="preview-proof">
      <div className="preview-container">
        <div className="preview-section-header">
          <h2>{data.title}</h2>
          <p>{data.subtitle}</p>
        </div>

        <div className="preview-proof__tableWrap">
          <table className="preview-proof__table">
            <thead>
              <tr>
                {headers.slice(0, 3).map((h, i) => (
                  <th key={i} className={i === hc ? "is-highlight" : ""}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(data.rows || []).map((r, i) => (
                <tr key={i}>
                  <td>{r.criterion}</td>
                  <td className={hc === 1 ? "is-highlight" : ""}>
                    {r.us}
                  </td>
                  <td className={hc === 2 ? "is-highlight" : ""}>
                    {r.other}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
